import { formatPrice, mapProductStockToProductStatus, mapProductTypeToProductCategory } from '@grandvisionhq/svc-tealium/utils';
import '../../types/product.js';
import { SINGLE_PURCHASE } from '../../types/purchase-types.js';
import { isProductWithAFrame, isContactLens } from '../../types/typeguards.js';

const mapProductToTealiumProperties = (product, activeVariant)=>{
    const isPublished = product.isPublished && activeVariant.isPublished;
    const prices = activeVariant.purchaseTypePrices[SINGLE_PURCHASE];
    const originalPrice = formatPrice(prices.originalPrice, false);
    const discountedPrice = prices.discountedPrice ? formatPrice(prices.discountedPrice, false) : originalPrice;
    const productProperties = {
        Status: mapProductStockToProductStatus(activeVariant.stock.stockCount, isPublished),
        Category: mapProductTypeToProductCategory(product.productType),
        Price: discountedPrice,
        PriceFull: originalPrice,
        ModelName: product.name
    };
    if (isProductWithAFrame(product) || isContactLens(product)) {
        productProperties.LensType = 'PLANO';
    }
    return productProperties;
};

export { mapProductToTealiumProperties };
//# sourceMappingURL=map-product-to-tealium-properties.js.map
